import { ref, computed } from 'vue';
import { DEFAULT_PAGE_SIZE } from '../utils/constants';

export function useTimelinePagination(totalItemsGetter: () => number) {
    const currentPage = ref(1);
    const pageSize = ref(DEFAULT_PAGE_SIZE);

    const totalPages = computed(() => {
        const total = totalItemsGetter();
        return Math.ceil(total / pageSize.value);
    });

    const paginationStart = computed(() => {
        const total = totalItemsGetter();
        if (total === 0) return 0;
        return (currentPage.value - 1) * pageSize.value + 1;
    });

    const paginationEnd = computed(() => {
        const total = totalItemsGetter();
        const end = currentPage.value * pageSize.value;
        return end > total ? total : end;
    });

    const onPageSizeChange = (newSize: number) => {
        pageSize.value = newSize;
        currentPage.value = 1; // Reset to first page when page size changes
    };

    const goToFirstPage = () => {
        if (currentPage.value !== 1) {
            currentPage.value = 1;
        }
    };

    const goToPreviousPage = () => {
        if (currentPage.value > 1) {
            currentPage.value--;
        }
    };

    const goToNextPage = () => {
        if (currentPage.value < totalPages.value) {
            currentPage.value++;
        }
    };

    const goToLastPage = () => {
        if (currentPage.value !== totalPages.value) {
            currentPage.value = totalPages.value;
        }
    };

    return {
        currentPage,
        pageSize,
        totalPages,
        paginationStart,
        paginationEnd,
        onPageSizeChange,
        goToFirstPage,
        goToPreviousPage,
        goToNextPage,
        goToLastPage
    };
}
